
export const environment = {
  production: false,
  htvApiUrl: "https://api.hockeytv.htvstaging.com",
  apiUrl: "https://admin.staging.hockeytv.com/api",
  defaultHeaders: { }
};

